import { render } from "./OurGovernance.vue?vue&type=template&id=188eb3a0&scoped=true"
import script from "./OurGovernance.vue?vue&type=script&lang=js"
export * from "./OurGovernance.vue?vue&type=script&lang=js"

import "./OurGovernance.vue?vue&type=style&index=0&id=188eb3a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188eb3a0"]])

export default __exports__